import React from 'react'

function Header() {
  return (
    <h2>Expense Tracker</h2>
  )
}

export default Header